import bagongPilipinasLogo from '@/assets/BAGONG-PILIPINAS-LOGO.png';
import denrLogo from '@/assets/denr-logo.png';
import { format } from 'date-fns';

export const CSAWPrintTemplate = ({ certificate, orderOfPayment }) => {
   const formatDate = (timestamp) => {
      if (!timestamp) return null;
      try {
         return format(new Date(parseInt(timestamp)), 'MMMM d, yyyy');
      } catch (error) {
         console.error('Error formatting date:', error);
         return null;
      }
   };

   // Early return if no certificate data
   if (!certificate || !certificate.csawCertificateData) {
      console.error('Missing certificate data:', certificate);
      return null;
   }

   const {
      certificateNumber,
      dateIssued,
      expiryDate,
      csawCertificateData: {
         ownerName,
         address,
         purpose,
         chainsawDetails
      }
   } = certificate;

   return `
    <style>
      @media print {
        @page {
          size: A4;
          margin: 15mm;
        }
        body {
          font-family: Times New Roman, serif;
          color: #000;
          background: #fff;
          line-height: 1.3;
          font-size: 12pt;
        }
        .no-print {
          display: none !important;
        }
        .logo-container {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1rem;
        }
        .logo {
          height: 80px;
          width: auto;
        }
        .header {
          text-align: center;
          margin-bottom: 15px;
        }
        .title {
          font-size: 14pt;
          font-weight: bold;
          margin: 0;
        }
        .subtitle {
          font-size: 12pt;
          margin: 0;
        }
        .cert-number {
          font-size: 12pt;
          margin-top: 5px;
        }
        .content {
          text-align: justify;
        }
        .owner-info {
          text-align: center;
          margin: 15px 0;
        }
        .owner-name {
          font-size: 12pt;
          margin: 5px 0;
        }
        .label {
          font-size: 10pt;
          margin: 0;
        }
        .details-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 5px;
          margin: 5px 0;
        }
        .detail-item {
          margin: 3px 0;
        }
        .footer {
          text-align: center;
          font-size: 10pt;
          margin-top: 15px;
        }
        .signature-section {
          margin-top: 20px;
          text-align: center;
        }
        .signature-line {
          width: 200px;
          margin: 0 auto;
          border-top: 1px solid black;
          padding-top: 5px;
        }
      }
    </style>
    <div class="content">
      <div class="header">
        <div class="logo-container">
          <img src="${denrLogo}" alt="DENR Logo" class="logo" />
          <div>
            <p class="title">CERTIFICATE OF REGISTRATION</p>
            <p class="subtitle">Department of Environment and Natural Resources</p>
            <p class="subtitle">PENRO Marinduque</p>
          </div>
          <img src="${bagongPilipinasLogo}" alt="Bagong Pilipinas Logo" class="logo" />
        </div>
        <p class="cert-number">No. ${certificateNumber}</p>
      </div>

      <div class="content">
        <p>After having complied with the provisions of DENR Administrative Order No. 2003-24, Series of 2003 otherwise known as "The Implementing Rules and Regulations of the Chainsaw Act of 2002 (RA No. 9175)" entitled "AN ACT REGULATING THE OWNERSHIP, POSSESSION, SALE, IMPORTATION AND USE OF CHAINSAWS PENALIZING VIOLATIONS THEREOF AND FOR OTHER PURPOSES" this Certificate of Registration to own, possess and/or use a chainsaw is hereby issued to:</p>
      </div>

      <div class="owner-info">
        <p class="owner-name">${ownerName}</p>
        <p class="label">(Name of Owner)</p>
        <p class="owner-name">${address}</p>
        <p class="label">(Address)</p>
      </div>

      <p><strong>Bearing the following information and descriptions:</strong></p>
      <p><strong>Use of the Chainsaw:</strong> ${purpose}</p>

      <div class="details-grid">
        <div>
          <p class="detail-item"><strong>Brand:</strong> ${chainsawDetails.brand}</p>
          <p class="detail-item"><strong>Model:</strong> ${chainsawDetails.model}</p>
          <p class="detail-item"><strong>Serial No:</strong> ${chainsawDetails.serialNumber}</p>
          <p class="detail-item"><strong>Date of Acquisition:</strong> ${formatDate(chainsawDetails.dateOfAcquisition)}</p>
        </div>
        <div>
          <p class="detail-item"><strong>Power Output:</strong> ${chainsawDetails.powerOutput}</p>
          <p class="detail-item"><strong>Maximum Length of Guidebar:</strong> ${chainsawDetails.maxLengthGuidebar}</p>
          <p class="detail-item"><strong>Country of Origin:</strong> ${chainsawDetails.countryOfOrigin}</p>
          <p class="detail-item"><strong>Purchase Price:</strong> ₱${chainsawDetails.purchasePrice.toFixed(2)}</p>
        </div>
      </div>

      <p><strong>Issued on:</strong> ${formatDate(dateIssued)} at DENR-PENRO Marinduque</p>
      <p><strong>Expiry Date:</strong> ${formatDate(expiryDate)}</p>

      <div class="signature-section">
        <p><strong>APPROVED BY:</strong></p>

          ${certificate.signature?.data ?
         `<img src="data:${certificate.signature.contentType};base64,${certificate.signature.data}"
                 alt="PENR Officer Signature"
                 style="max-height: 60px; margin: 0 auto; display: block;">`
         : ''}
            <div class="signature-line">
          <p style="margin: 0; font-weight: bold;">IMELDA M. DIAZ</p>
          <p style="margin: 0;">OIC-PENR Officer</p>
        </div>
      </div>

      <div style="margin-top: 30px;">
        <p>Amount paid: Php ${orderOfPayment?.officialReceipt?.amount?.toFixed(2) || '500.00'}</p>
        <p>O.R. No.: ${orderOfPayment?.officialReceipt?.orNumber || '_______________'}</p>
        <p>Date: ${orderOfPayment?.officialReceipt?.dateIssued ? formatDate(orderOfPayment.officialReceipt.dateIssued) : '_________________'}</p>
      </div>

      <div class="footer">
        <p>***Not valid w/o PENRO Official Seal***</p>
        <p>Capitol Compound, Barangay Bangbangalon, Boac, Marinduque</p>
      </div>
    </div>
  `;
};
